export const SCREEN_SIZE = {
    XS: 415,
    SM: 569,
    MD: 769,
    LG: 992,
    XL: 1141,
    XXL: 1281,
};
